// XentriPay provider ids for Rwandan mobile money wallets.
export const PROVIDERS = [
  { id: '63510', key: 'mtn' },
  { id: '63514', key: 'airtel' },
];

export function providerLabel(t, providerId) {
  const match = PROVIDERS.find((p) => p.id === providerId);
  return match ? t(`payouts_page.providers.${match.key}`) : '—';
}

export const PAYOUT_STATUS_TONE = {
  pending: 'pending',
  completed: 'paid',
  successful: 'paid',
  failed: 'completed',
  reversed: 'inactive',
};
